module.exports = __webpack_public_path__ + "img/British Virgin Islands.1071f956.svg";